module.exports = __webpack_public_path__ + "media/img/pages/career-starter/collection/2019_de-faecec28c88cefe61de39bf2e5f3e1f3.jpg";